import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo_chg_white.png";
import { useTranslation } from "react-i18next";


export const Footer = () => {
  const [t] = useTranslation("global");
  return (
    <footer className="footer px-0">
      <Container className="px-0">
        <Row className="align-items-center row-p-0 mx-0">
          <MailchimpForm className="px-0"/>
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <p>{t("copyright")}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
